import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { CandidateEntry } from '../Dto/CandidateEntry';
import { map } from 'rxjs/operators';

@Injectable()
export class EntryLogs {
  constructor(private http: HttpClient) {
  }

  saveEntryUrl = environment.settings.apiEndpoint + '/api/RecruitmentRedirect/SaveRedirectEvent/';
  saveCandidateEntryUrl = environment.settings.apiEndpoint + '/api/RecruitmentRedirect/SaveCandidateEntry';
  getIpUrl = 'https://api.ipify.org?format=json';

  saveEntry(guid) {
    return this.http.get(this.saveEntryUrl + '/' + guid);
  }
  saveCandidateEntry(candidate: CandidateEntry) {
    return this.http.post(this.saveCandidateEntryUrl, candidate);
  }
  getIP() {
    return this.http.get(this.getIpUrl);
  }
  getIp() {
    return this.http.get<any>(this.getIpUrl).pipe(map<any, string>(x => x.ip));
  }
}
